import type { ReactNode } from "react";

type SectionHeadingProps = {
  index: string;
  label: string;
  title: ReactNode;
  id: string;
  children?: ReactNode;
  aside?: ReactNode;
};

export function SectionHeading({ index, label, title, id, children, aside }: SectionHeadingProps) {
  return (
    <div className="section-heading">
      <p className="index-label">
        <span className="index-label__number">{index}</span>
        <span>{label}</span>
      </p>
      <div className="section-heading__row">
        <h2 className="display" id={id}>{title}</h2>
        {aside ? <div className="section-heading__aside">{aside}</div> : null}
      </div>
      {children ? <p className="section-heading__lede">{children}</p> : null}
    </div>
  );
}
